"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tooltip = void 0;

var React = _interopRequireWildcard(require("react"));

var mapboxgl = _interopRequireWildcard(require("mapbox-gl"));

var _Map = require("./Map");

var Tooltip = function Tooltip(_ref) {
  var onLayer = _ref.onLayer,
      children = _ref.children;
  var map = React.useContext(_Map.MapContext);
  var div = document.createElement('div');
  React.useEffect(function () {
    if (onLayer) {
      map === null || map === void 0 ? void 0 : map.on('click', onLayer, function (e) {
        new mapboxgl.Popup().setLngLat(e.lngLat).setDOMContent(div).addTo(map);
      });
    } else {
      map === null || map === void 0 ? void 0 : map.on('click', function (e) {
        new mapboxgl.Popup().setLngLat(e.lngLat).setDOMContent(div).addTo(map);
      });
    }
  }, [map, children, div, onLayer]);
  return /*#__PURE__*/React.createElement("div", null);
};

exports.Tooltip = Tooltip;